import React from 'react'
import { useTranslation } from 'react-i18next'

import { CwsButton, CwsCard, CwsCardBody, CwsP, CwsSection } from '../../cms-web-styleguide-exports'
import s from './Coupons.module.scss'

export default function NoCoupons() {
  const { t } = useTranslation()

  return (
    <CwsCard className={`${s.card} cws-p-l`}>
      <CwsCardBody backgroundColor="white">
        <CwsSection className={s.wrapper}>
          <CwsP className={s.text} hideSpacing>
            {t('no.codes.available')}
          </CwsP>
          <CwsButton className={s.button} href="/" width="fluid">
            {t('button.buy.cta')}
          </CwsButton>
        </CwsSection>
      </CwsCardBody>
    </CwsCard>
  )
}
